export default function ($stateProvider, SABLONO_STATES) {
    "ngInject";

    $stateProvider.state(SABLONO_STATES.myWork, {
        template: "<sb-app-my-work></sb-app-my-work>",
        url: "/my-work",
        gaPageTrack: "/my-work",
        data: {
            title: "SECTION_MY_WORK",
            category: "CONTROL",
        },
        onEnter: function (Analytics) {
            "ngInject";
            Analytics.trackNorthStarExploration("open start page");
        },
    });

    const noteTemplatesQueryParams = [
        "type",
        "creator",
        "search_term",
        "sort",
        "open",
        "mode",
        "code",
    ];

    $stateProvider.state(SABLONO_STATES.noteTemplatesV2, {
        template: "<sb-app-note-templates></sb-app-note-templates>",
        url: "/note-templates?" + noteTemplatesQueryParams.join("&"),
        gaPageTrack: "/note-templates",
        reloadOnSearch: false,
        data: {
            title: "ACTION_NAV_TO_TEMPLATE_NOTES",
            category: "PLAN",
        },
        onEnter: function (intercomService, TRACKED_EVENTS) {
            intercomService.track(TRACKED_EVENTS.ENTERED_NOTE_TEMPLATES_PAGE);
        },
    });

    $stateProvider.state("sablono.project.templates", {
        template: "<sb-app-process-templates></sb-app-process-templates>",
        url: "/templates?init",
        reloadOnSearch: false,
        gaPageTrack: "/templates", // google analytics extension
        data: {
            title: "SECTION_TEMPLATES_TITLE",
            category: "PLAN",
            searchEnabled: false,
        },
        onEnter: function (intercomService, TRACKED_EVENTS) {
            intercomService.track(
                TRACKED_EVENTS.ENTERED_WORKFLOW_TEMPLATES_PAGE
            );
        },
    });

    $stateProvider.state("sablono.project.processTemplateEditor", {
        template:
            "<sb-app-process-template-editor-page></sb-app-process-template-editor-page>",
        url: "/template/editor-v2/{templateId:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}",
        gaPageTrack: "/template/editor-v2",
        data: {
            title: "SECTION_TEMPLATE_EDITOR",
            category: "PLAN",
        },
        onEnter: function (intercomService, TRACKED_EVENTS) {
            "ngInject";

            intercomService.track(
                TRACKED_EVENTS.ENTERED_WORKFLOW_TEMPLATES_EDITOR_PAGE
            );
        },
    });

    const dashboardProQueryParams = [
        "structures",
        "processTemplate",
        "deliverableType",
        "workTeams",
        "activity",
        "dateRange",
        "scheduleType",
        "dashboard",
        "hasAttachedQA",
    ];

    $stateProvider.state("sablono.project.dashboardPro", {
        template:
            "<sb-app-performance-dashboard-pro></sb-app-performance-dashboard-pro>",
        url: "/dashboards-pro?" + dashboardProQueryParams.join("&"),
        gaPageTrack: "/dashboards-pro",
        data: {
            title: "SECTION_DASHBOARD_PRO",
            category: "CONTROL",
        },
        onEnter: function (intercomService, TRACKED_EVENTS) {
            "ngInject";
            intercomService.track(TRACKED_EVENTS.ENTERED_DASHBOARD_PRO_PAGE);
        },
    });

    const packageTrackerQueryParams = ["search", "structures", "package"];

    $stateProvider.state(SABLONO_STATES.packageTracker, {
        template: "<sb-app-package-tracker></sb-app-package-tracker>",
        url: "/package-tracker?" + packageTrackerQueryParams.join("&"),
        reloadOnSearch: false,
        gaPageTrack: "/package-tracker",
        data: {
            category: "REVIEW",
            title: "ACTION_NAV_TO_PACKAGE_TRACKER",
        },
        onEnter: function (Analytics) {
            "ngInject";
            Analytics.trackNorthStarExploration("open package tracker");
        },
    });

    $stateProvider.state("sablono.profile", {
        template: "<sb-app-profile></sb-app-profile>",
        url: "/profile",
        data: {
            title: "SECTION_USER_PROFILE_TITLE",
        },
        onEnter: function (intercomService, TRACKED_EVENTS) {
            "ngInject";
            intercomService.track(TRACKED_EVENTS.ENTERED_PROFILE_PAGE);
        },
    });

    $stateProvider.state("sablono.projectsAdministration", {
        url: "/projects-administration?search_term&projects&sort",
        reloadOnSearch: false,
        gaPageTrack: "/projects-administration",
        template:
            "<sb-app-projects-administration></sb-app-projects-administration>",
        data: {
            category: "PLAN",
            title: "SECTION_PROJECTS_ADMINISTRATION_TITLE",
            icon: "mdi mdi-account-group",
        },
    });

    $stateProvider.state("sablono.project.commercialValuation", {
        template: "<sb-app-commercial-valuation></sb-app-commercial-valuation>",
        url: "/commercial-valuation",
        gaPageTrack: "/commercial-valuation",
        data: {
            title: "SECTION_COMMERCIAL_PRO_PAGE_TITLE",
            category: "REVIEW",
        },
        onEnter: function (intercomService, TRACKED_EVENTS) {
            "ngInject";
            intercomService.track(
                TRACKED_EVENTS.ENTERED_COMMERCIAL_VALUATION_PAGE
            );
        },
    });

    $stateProvider.state("sablono.projectSelection", {
        url: "/projectSelection",
        template:
            '<sb-app-project-selection id="sbAppProjectSelection"></sb-app-project-selection>',
        data: {
            appCategory: "PLAN",
            title: "SECTION_PROJECT_SELECTION_TITLE",
            icon: "sb-icon-project_overview",
            searchEnabled: true,
            searchPlaceholder:
                "INFO_PLACEHOLDER_SEARCH_BAR_PROJECT_SELECTION_MESSAGE",
        },
        onEnter: function (
            $sbCurrentProject,
            $sbProjectCurrentSettings,
            $sbMembership
        ) {
            "ngInject";
            $sbCurrentProject.unset();
            $sbProjectCurrentSettings.clear();
            $sbMembership.clearCache();
        },
        controller: function (
            $sbCurrentProject,
            $log,
            $scope,
            $sbAuth,
            $sbProjectApi,
            EVENTS,
            $sbErrorPresenter,
            $sbPageNavigation
        ) {
            "ngInject";

            const element = document.getElementById("sbAppProjectSelection");

            var searchListener = $scope.$on(
                EVENTS.GLOBAL_SEARCH_CHANGE,
                function (_, eventData) {
                    element.projectSearch = eventData.searchTerm;
                }
            );

            $scope.$on("$destroy", function () {
                searchListener();
            });

            element.navigateIntoProject = (projectId) => {
                $log.info("opening project", projectId);
                return $sbProjectApi
                    .get(projectId)
                    .then((project) => $sbCurrentProject.set(project))
                    .then((project) =>
                        $sbPageNavigation.goToLandingPage(project)
                    )
                    .catch($sbErrorPresenter.catch);
            };

            element.navigateToSignup = () => {
                $log.info("logout and nav to signup");
                $sbAuth.signOut({
                    state: "account.register",
                });
            };
        },
    });
}
